import {
  type CurrencyConfig,
  type CurrencyKey,
  type SliderConfig,
  type SliderInput,
} from './types';

export const DEFAULT_INPUTS: SliderInput = {
  totalEmployees: 500,
  predictedGrowthPercent: 5,
  desktopWorkersPercent: 40,
  estimatedYearlyChurn: 10,
  averageDesktopSalary: 90000,
  averageFrontlineSalary: 50000,
};

export const SLIDER_CONFIGS: SliderConfig[] = [
  {
    field: 'totalEmployees',
    label: 'How many employees do you have?',
    min: 500,
    max: 60000,
    step: 100,
    format: 'number',
  },
  {
    field: 'predictedGrowthPercent',
    label: 'Predicted growth per annum (of employees)',
    min: 0,
    max: 30,
    step: 1,
    format: 'percent',
  },
  {
    field: 'desktopWorkersPercent',
    label: '% of desktop workers?',
    min: 0,
    max: 100,
    step: 5,
    format: 'percent',
  },
  {
    field: 'estimatedYearlyChurn',
    label: 'Estimated yearly churn',
    min: 0,
    max: 30,
    step: 1,
    format: 'percent',
  },
  {
    field: 'averageDesktopSalary',
    label: 'Average salary of desktop worker',
    min: 0,
    max: 150000,
    step: 1000,
    format: 'currency',
  },
  {
    field: 'averageFrontlineSalary',
    label: 'Average salary of frontline worker',
    min: 0,
    max: 150000,
    step: 1000,
    format: 'currency',
  },
];

export const CURRENCY_CONFIGS: Record<CurrencyKey, CurrencyConfig> = {
  usd: { symbol: '$', workingWeeksPerYear: 48, workingHoursPerYear: 1800 },
  gbp: { symbol: '£', workingWeeksPerYear: 46, workingHoursPerYear: 1725 },
  eur: { symbol: '€', workingWeeksPerYear: 45, workingHoursPerYear: 1687.5 },
};

// Working time constants (shared across all currencies)
export const WORKING_DAYS_PER_WEEK = 5;
export const WORKING_DAYS_PER_MONTH = 21;
export const WORKING_HOURS_PER_DAY = 7.5;
export const WORKING_HOURS_PER_WEEK = 37.5;
export const WORKING_HOURS_PER_MONTH = 157.5;

// Report calculation constants
export const INFLATION_INCREASE = 3;
export const UNFORESEEABLE_BUSINESS_CHANGE = 35;

// Productivity Yield - Desktop
export const DESKTOP_EXPECTED_SAVING = 3;
export const DESKTOP_TIME_CAPTURED_PERCENT = 15;
export const DESKTOP_ACTIVE_USERS_PERCENT: [number, number, number] = [60, 75, 80];

// Productivity Yield - Frontline
export const FRONTLINE_EXPECTED_SAVING = 2;
export const FRONTLINE_TIME_CAPTURED_PERCENT = 7.5;
export const FRONTLINE_ACTIVE_USERS_PERCENT: [number, number, number] = [40, 55, 60];

// Onboarding Gains
export const PRODUCTIVITY_LEVEL_FIRST_THREE_MONTHS = 50;
export const DESKTOP_PRODUCTIVITY_IMPROVEMENT = 5;
export const FRONTLINE_PRODUCTIVITY_IMPROVEMENT = 2.5;
export const DESKTOP_TIME_CAPTURED_PRODUCTIVITY = 5;
export const FRONTLINE_TIME_CAPTURED_PRODUCTIVITY = 3;

// Retention Returns
export const DESKTOP_REPLACEMENT_COST_PERCENT = 20;
export const FRONTLINE_REPLACEMENT_COST_PERCENT = 15;
export const DESKTOP_INTRANET_CHURN_IMPACT = 0.3;
export const FRONTLINE_INTRANET_CHURN_IMPACT = 0.1;

// localStorage key
export const STORAGE_KEY = 'interact-roi-report';

// Chart colors (brand tokens mapped to hex for Recharts)
export const CHART_COLORS = {
  plum: '#471a34',
  plumLight: '#723c57',
  orangeDark: '#fc945b',
};
